import { MdBusinessCenter, MdVideocam, MdHome, MdCategory } from "react-icons/md";

type ServiceRangeBadgesProps = {
  serviceRanges: string[];
};

export const ServiceRangeBadges = ({ serviceRanges }: ServiceRangeBadgesProps) => {
  if (serviceRanges.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {serviceRanges.map((range) => {
        const normalized = range.toLowerCase();
        // Format range text: replace underscores with spaces
        const formattedRange = range.replace(/_/g, ' ');
        let badgeClasses = "bg-[#F3F4F6] text-[#4B5563] ";
        let IconComponent = MdCategory;
        let iconClassName = "h-5 w-5";
        let iconColor = "black";
        if (normalized.includes("office")) {
          badgeClasses = "bg-[#026857] text-white";
          IconComponent = MdBusinessCenter;
          iconClassName = "h-5 w-5";
          iconColor = "white";
        } else if (normalized.includes("virtual")) {
          badgeClasses = "bg-[#026857] text-white";
          IconComponent = MdVideocam;
          iconColor = "white";
        } else if (normalized.includes("home")) {
          badgeClasses = "bg-[#026857] text-white";
          IconComponent = MdHome;
          iconColor = "white";
        }
        return (
          <span
            key={range}
            className={`px-4 py-1.5 rounded-full text-sm font-termina uppercase tracking-[0.12em] inline-flex items-center justify-center gap-2 ${badgeClasses}`}
          >
            <IconComponent
              className={`${iconClassName} flex-shrink-0`}
              style={{ color: iconColor }}
              aria-hidden="true"
            />
            <span className="leading-none capitalize font-semibold">{formattedRange}</span>
          </span>
        );
      })}
    </div>
  );
};

